import {Injectable} from '@angular/core';
import {SharedService} from '../shared/shared-service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {tap} from 'rxjs/operators';
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})

export class ReferencesService {

  constructor(public sharedService: SharedService, public http: HttpClient, private cookieService: CookieService) {
  }

  getAllReferencesByType(type) {
    return this.http.get(environment.serverLink + '/references/' + type, this.sharedService.generateHttpHeaders());
  }

  saveGoldenRuleOrLinks(data, type) {
    return this.http.post(environment.serverLink + '/references/saveGoldenRuleOrLinks/' + type, data, this.sharedService.generateHttpHeaders()).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  savePoliciesOrDocuments(data, type) {
    return this.http.post(environment.serverLink + '/references/savePoliciesOrDocuments/' + type, data, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.cookieService.get('securityToken')
      })
    }).pipe(tap(result => {
      return result;
    }, error => {
      return error;
    }));
  }

  editReference(data) {
    return this.http.patch(environment.serverLink + '/references/editGoldenRule', data, this.sharedService.generateHttpHeaders())
  }

  deleteReferenceById(referenceId, param?: any) {
    return this.http.post(environment.serverLink + '/references/' + referenceId, param, this.sharedService.generateHttpHeaders()).pipe(
      tap(
        data => {
          return data;
        },
        error => {
          return error;
        }));
  }

  getAndLoadFile(url) {
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-type': 'application/json',
        responseType: 'text'
      })
    });
  }
}
